if (!process.env.VUE_APP_IS_WEB) {
  var BuildingLotDB = require("../database/models/BuildingLot");

  var BuildingOwnerBuildingLotDB = require("../database/models/BuildingOwnerBuildingLot");
}
import strings from "@/database/strings";

import BuildingLotORM from "@/store/orm-axios/models/BuildingLot";

import BuildingOwnerBuildingLotORM from "@/store/orm-axios/models/BuildingOwnerBuildingLot";
import BuildingOwnerVotingRightORM from "@/store/orm-axios/models/BuildingOwnerVotingRight";

import BuildingOwnerVotingRightMW from "./BuildingOwnerVotingRight";

export default {
  FETCH(buildingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new BuildingLotDB()
          .query({ where: { deleted: null, building_id: buildingId } })
          .fetchAll({
            withRelated: [
              {
                building_owner_building_lots: query => {
                  query.where("deleted", null);
                },
              },
            ],
          })
          .then(res => {
            BuildingLotORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingLotORM.api()
          .FETCH(buildingId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new BuildingLotDB({ id: id, deleted: null })
          .fetch()
          .then(res => {
            BuildingLotORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingLotORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  POST(item, buildingOwnerId) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPost = JSON.parse(JSON.stringify(item));
      itemPost.slug = strings.get_slug(itemPost.name);
      return new Promise((resolve, reject) => {
        new BuildingLotDB(itemPost)
          .save()
          .then(res => {
            var buildingLot = res.serialize();
            BuildingLotORM.insertOrUpdate({
              data: buildingLot,
            });
            var buildingOwnerBuildingLot = {
              building_lot_id: buildingLot.id,
              building_owner_id: buildingOwnerId,
            };
            new BuildingOwnerBuildingLotDB(buildingOwnerBuildingLot)
              .save()
              .then(res2 => {
                BuildingOwnerBuildingLotORM.insertOrUpdate({
                  data: res2.serialize(),
                });
                resolve(buildingLot);
              })
              .catch(err2 => {
                reject(err2);
              });

            // ???: renounce
            /**
       // console.log("res", res);
            // EX: when there is a many-to-many relationship (create + attach)
            res
              .building_owners()
              .attach(buildingOwnerId)
              .then(relation => {
                BuildingLotORM.insertOrUpdate({
                  data: res.serialize(),
                });
                resolve(res.serialize());
              });
            */
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingLotORM.api()
          .POST(item)
          .then(res => {
            var buildingLot = res.response.data;
            var buildingOwnerBuildingLot = {
              building_lot_id: buildingLot.id,
              building_owner_id: buildingOwnerId,
            };
            BuildingOwnerBuildingLotORM.api()
              .POST(buildingOwnerBuildingLot)
              .then(() => {
                resolve(buildingLot);
              })
              .catch(err2 => {
                reject(err2);
              });
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  ATTACH(itemId, buildingOwnerId) {
    var buildingOwnerBuildingLot = {
      building_lot_id: itemId,
      building_owner_id: buildingOwnerId,
    };
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new BuildingOwnerBuildingLotDB(buildingOwnerBuildingLot)
          .save()
          .then(res => {
            BuildingOwnerBuildingLotORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });

        // ???: renounce
        /**
        new BuildingLotDB({ id: itemId })
          .building_owners()
          .attach(buildingOwnerId)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
        */
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerBuildingLotORM.api()
          .POST(buildingOwnerBuildingLot)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DETACH(itemId, buildingOwnerId, pivotId) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new BuildingOwnerBuildingLotDB({ id: pivotId })
          .save(null, { isDelete: true })
          .then(res => {
            // HACK: delete related voting rights when detaching
            var votingRightsDelete = BuildingOwnerVotingRightORM.query()
              .where("building_owner_has_building_lot_id", pivotId)
              .get();
            votingRightsDelete.forEach(async item => {
              await BuildingOwnerVotingRightMW.DELETE(item);
            });

            BuildingOwnerBuildingLotORM.delete(pivotId);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });

        // ???: renounce
        /**
        new BuildingLotDB({ id: itemId })
          .building_owners()
          .detach(buildingOwnerId)
          .then(res => {
            // HACK: delete related voting rights when detaching
            var votingRightsDelete = BuildingOwnerVotingRightORM.query()
              .where("building_owner_has_building_lot_id", pivotId)
              .get();
            votingRightsDelete.forEach(async item => {
              await BuildingOwnerVotingRightMW.DELETE(item);
            });

            BuildingOwnerBuildingLotORM.delete(item => {
              return item.id == pivotId;
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
        */
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingOwnerBuildingLotORM.api()
          .DELETE(pivotId)
          .then(res => {
            // HACK: delete related voting rights when detaching
            var votingRightsDelete = BuildingOwnerVotingRightORM.query()
              .where("building_owner_has_building_lot_id", pivotId)
              .get();
            votingRightsDelete.forEach(async item => {
              await BuildingOwnerVotingRightMW.DELETE(item);
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      itemPut.slug = strings.get_slug(itemPut.name);
      return new Promise((resolve, reject) => {
        new BuildingLotDB(itemPut)
          .save(null, { isUpdate: true })
          .then(res => {
            BuildingLotORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingLotORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  DELETE(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemDelete = JSON.parse(JSON.stringify(item));
      return new Promise((resolve, reject) => {
        new BuildingLotDB(itemDelete)
          .save(null, { isDelete: true })
          .then(res => {
            BuildingLotORM.delete(item.id);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        BuildingLotORM.api()
          .DELETE(item)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  REGISTER_GET_BUILDING_LOTS(meetingId) {
    if (!process.env.VUE_APP_IS_WEB) {
      // TODO: Needs implementation..
    } else {
      return new Promise((resolve, reject) => {
        BuildingLotORM.api()
          .REGISTER_GET_BUILDING_LOTS(meetingId)
          .then(res => {
            BuildingLotORM.create({
              data: res.response.data["hydra:member"],
            });
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
